<section class="inner-page-section inner-search-section">
  <div class="container">
    <form [formGroup]="searchForm" *ngIf="!isCountrySearch" (ngSubmit)="onSearch()">
      <div class="search-section">
        <div class="select-sec">
          <label>Select Origin</label>
          <div class="select-section-relative input-section pRel">
            <p-dropdown formControlName="fromCountry" [options]="masterSourceCountries" optionLabel="countryName"
                        [filter]="true" filterMatchMode="startsWith" placeholder="From Country" 
                        [itemSize]="31" [virtualScroll]="true" (onChange)="onSourceCountrySelect($event)">
            </p-dropdown>
          </div>

          <div class="select-section-relative pRel">
            <p-multiSelect formControlName="fromPort" [options]="masterSourcePorts" optionLabel="portName" defaultLabel="From Port" [selectedItemsLabel]="'{0} items selected'"
                           [filter]="true" filterMatchMode="startsWith" selectionLimit="5" [maxSelectedLabels]="1" 
                           [itemSize]="31" [virtualScroll]="true" (onChange)="onSourcePortChange($event)">
            </p-multiSelect>
          </div>
        </div>


        <div class="select-sec revert-arrow">
          <img src="https://img.icons8.com/android/20/ffffff/minus.png" style="vertical-align: inherit;">
        </div>
        <div class="select-sec">
          <label>Select Destination</label>

          <div class="select-section-relative input-section pRel">
            <p-dropdown formControlName="toCountry" [options]="masterDestinationCountries" optionLabel="countryName"
                        [filter]="true" filterMatchMode="startsWith" placeholder="To Country" 
                        [itemSize]="31" [virtualScroll]="true" (onChange)="onDestinationCountrySelect($event)">
            </p-dropdown>
          </div>

          <div class="select-section-relative pRel">
            <p-multiSelect formControlName="toPort" [options]="masterDestinationPorts" optionLabel="portName" defaultLabel="To Port" [selectedItemsLabel]="'{0} items selected'"
                           [filter]="true" filterMatchMode="startsWith" selectionLimit="5" [maxSelectedLabels]="1">
            </p-multiSelect>
          </div>

        </div>
        <div class="select-sec">
          <label>Date</label>
          <div class="select-section-relative input-section pRel">
            <p-calendar formControlName="date" [readonlyInput]="true" showIcon="true" showButtonBar="true"
                        placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                        icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy"></p-calendar>
          </div>
        </div>
        <div class="btn-go-sec">
          <div class="select-section-relative input-section pRel">
            <button pButton type="submit" label="Submit"
                    class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>

            <button pButton type="button" style="margin-left: 0.7em;" label="Reset" (click)="ResetSearchFilter()"
                    class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="searchForm" *ngIf="isCountrySearch" (ngSubmit)="onSearchByCountry()">
      <div class="search-section">
        <div class="select-sec">
          <label>Select Origin</label>
          <div class="select-section-relative input-section pRel">
            <p-dropdown formControlName="fromCountry" [options]="masterSourceCountries" optionLabel="countryName"
                        [filter]="true" filterMatchMode="startsWith" placeholder="From Country" 
                        [itemSize]="31" [virtualScroll]="true" (onChange)="onSourceCountrySelect($event)">
            </p-dropdown>
          </div>
        </div>


        <div class="select-sec revert-arrow">
          <img src="https://img.icons8.com/android/20/ffffff/minus.png" style="vertical-align: inherit;">
        </div>
        <div class="select-sec">
          <label>Select Destination</label>

          <div class="select-section-relative input-section pRel">
            <p-dropdown formControlName="toCountry" [options]="masterDestinationCountries" optionLabel="countryName"
                        [filter]="true" filterMatchMode="startsWith" placeholder="To Country" 
                        [itemSize]="31" [virtualScroll]="true" (onChange)="onDestinationCountrySelect($event)">
            </p-dropdown>
          </div>
        </div>
        <div class="select-sec">
          <label>Date</label>
          <div class="select-section-relative input-section pRel">
            <p-calendar formControlName="date" [readonlyInput]="true" showIcon="true" showButtonBar="true"
                        placeholder="Date" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                        icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy"></p-calendar>
          </div>
        </div>
        <div class="btn-go-sec">
          <div class="select-section-relative input-section pRel">
            <button pButton type="submit" label="Submit"
                    class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>

            <button pButton type="button" style="margin-left: 0.7em;" label="Reset" (click)="ResetSearchFilter()"
                    class="btn btn-outline-success btn-go btn-submit my-2 my-sm-0"></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<section class="time-overview-sec">
  <div class="container">
    <div class="tosBox">
      <p-progressSpinner *ngIf="showloader" [style]="{width: '50px', height: '50px'}" class="spinner-sec"
                         strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
      <!-- <p-chart type="bar" *ngIf="!showloader" [data]="data" [options]="options" [responsive]="true" height="200"
        width="400"></p-chart> -->
    </div>
  </div>
</section>
<section class="tabs-details">
  <div class="container">
    <div class="tabs-details-inner">
      <div class="tab-item">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link" [ngClass]="!landingPageSearch?.searchBy || landingPageSearch?.searchBy == '6' ? 'active' : ''"
               id="home-tab" data-toggle="tab" role="tab" aria-controls="home"
               aria-selected="true" (click)=gettabDetails(6)>Earliest arrival</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [ngClass]="landingPageSearch?.searchBy == '1' ? 'active' : ''"
               id="home-tab" data-toggle="tab" role="tab" aria-controls="home"
               aria-selected="true" (click)=gettabDetails(1)>Earliest departure</a>
          </li>
          <!--

            TEMP HIDE, FIX FUNCTIONALITY


            <li class="nav-item">
            <a class="nav-link" *ngIf="isPermission != true" id="profile-tab" aria-disabled="true" data-toggle="tab"
              href="#profile" role="tab" aria-controls="profile" aria-selected="false"
              (click)='gettabDetails(quickest)'>Quickest</a>
          </li> -->
          <!-- <li class="nav-item">
            <a class="nav-link" *ngIf="isPermission != true" id="contact-tab" data-toggle="tab" href="#contact"
              role="tab" aria-controls="contact" aria-selected="false" (click)='gettabDetails(cheapest)'>Cheapest</a>
          </li> -->
        </ul>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': scheduleRroute == 0}" id="home-tab" data-toggle="tab" role="tab" aria-controls="home"
               aria-selected="true" (click)='getscheduleRrouting(0)'>Direct</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [ngClass]="{'active': scheduleRroute == 1}" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true"
               (click)='getscheduleRrouting(1)'>Transhipment</a>
          </li>
        </ul>
      </div>

      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
          <div class="container">
            <div class="row">
              <div class="col-lg-3">
                <div class="filter-sec">
                  <p-accordion>
                    <p-accordionTab header="Shipping Lines" [selected]="true">
                      <div class="shipping-sec">
                        <div class="shipping-lines">
                          <div class="select-section-relative">
                            <p-multiSelect [options]="shippingLines" [(ngModel)]="selectedShipLines"
                                           optionLabel="shippingLineName" [virtualScroll]="true" [filter]="false" [itemSize]="40"
                                           (onChange)="getSelectedShippingLine($event)">
                            </p-multiSelect>
                          </div>
                          <div class="box-sec-outer" style="display: block;margin-top: 5px;">
                            <ul class="list-group border-0">
                              <li class="list-group-item d-flex justify-content-between align-items-center border-0"
                                  style="padding: 0.3rem 0.25rem;" *ngFor="let ship of selectedShipLines; let i = index;">
                                {{ship.shippingLineName}}
                                <span class="badge badge-secondary badge-pill" (click)='removeShips(ship)'
                                      style="cursor: pointer;">
                                  x
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab header="Times">
                      <section class="timer-sec">
                        <div class="departure-sec">
                          <h4>Departure {{departurePortName}}</h4>
                          <div class="departure-sec-inner">
                            <div class="time-image" *ngIf="IsFilter">
                              <ngx-slider [(value)]="valueArrival" [options]="arroption"
                                (userChangeEnd)="fromPortChangeSlidder($event)">
                              </ngx-slider>
                            </div>
                          </div>
                        </div>
                        <div class="departure-sec">
                          <h4>Arrival {{arrivalPortName}}</h4>
                          <div class="departure-sec-inner">
                            <div class="time-image" *ngIf="IsFilter">
                              <ngx-slider [(value)]="valueDep" [options]="OptionsDep"
                                (userChangeEnd)="toPortChangeSlidder($event)">
                              </ngx-slider>
                            </div>
                          </div>
                        </div>
                      </section>
                    </p-accordionTab>
                    <p-accordionTab header="Transhipment Ports" *ngIf="transhipmentPorts.length > 0">
                      <section class="timer-sec">
                        <div class="departure-sec">
                          <p-dropdown [options]="transhipmentPorts" [(ngModel)]="selectedTranshipmentPort"
                                      optionLabel="portName" class="select-dropdown-sec" placeholder="Select Port"
                                      [virtualScroll]="true" (onChange)="filterByTranshipmentPorts($event)" [itemSize]="5"
                                      [filter]="false"></p-dropdown>
                        </div>
                      </section>
                    </p-accordionTab>
                  </p-accordion>
                </div>
                <div class="serachresultfiter filter-sec mt-1">
                  ENL Solutions is not responsible for the accuracy of the
                  information.The information can be changed by the
                  shipping line at any time and without any notice
                </div>

                <div class="serachresultfiter filter-sec mt-1">
                  <p>

                    ENL Solutions is currently only providing schedules from PCTC operating lines. Schedules from over 20 different PCTC lines are searchable.
                  </p>



                </div>

              </div>
              <div class="col-lg-9">
                <div class="table-sec">
                  <div class="table-responsive">
                    <!-- <table class="table"> -->
                    <p-table class="table" [value]="searchResult" *ngIf="totalCount > 0">
                      <ng-template pTemplate="header" let-result>
                        <tr>
                          <th class="fromviato-section">
                            <div class="flexdiv mobile-styling col-lg-12">
                              <div class="col-lg-2" *ngIf="scheduleRroute == 0"></div>
                              <div [ngClass]="scheduleRroute == 0?'col-lg-2':'col-lg-4' ">
                                <h5><b><u>From</u></b></h5>
                              </div>
                              <div class="col-lg-1" *ngIf="scheduleRroute == 0"></div>
                              <div class="col-lg-4" *ngIf="scheduleRroute == 1">
                                <h5><b><u>Via</u></b></h5>
                              </div>
                              <div [ngClass]="scheduleRroute == 0?'col-lg-2':'col-lg-4' ">
                                <h5><b><u>To</u></b></h5>
                              </div>
                              <!-- <div class="table-header-rates">
                                <h5><b><u>$/CBM</u></b></h5>
                              </div>
                              <div class="table-header-action">
                                <h5><b><u>Action</u></b></h5>
                              </div> -->
                              <!-- <div class="col-lg-1" *ngIf="scheduleRroute == 0" style="padding-left: 0px !important;">
                                <h5><b><u>$/CBM</u></b></h5>
                              </div> -->
                              <div *ngIf="scheduleRroute == 0" [ngClass]="scheduleRroute == 0?'col-lg-4':'col-lg-3' ">
                              </div>
                            </div>
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-result let-rowIndex="rowIndex">
                        <tr class="tdvm search-result-table" tooltipPosition="top" *ngIf="result?.isTranshipment == 1"
                            [ngClass]="result?.isPremiumListing==1 && rowIndex<5 ? 'premiumListing':null">
                          <td class="mobile-td-styling">
                            <div class="flexdiv mobile-styling">
                              <div pTooltip="Vessels Name: {{result.vesselsName}}">
                                <img class="image1" src="{{result.companyLogo}}">
                                <div class="mobile-text-styling">
                                  <h4 class="mobile-only-text">From:</h4>
                                  <h4>{{result.fromPortName}}</h4>
                                </div>
                                <div class="date-info">Dep: {{result.fromPortArrivalDate | date: 'dd-MM-yyyy'}} </div>
                              </div>
                              <div>
                                <div class="text-transhipment"></div>
                              </div>
                              <div pTooltip="Vessels: {{result.toVesselsName}}">
                                <img class="image1" src="{{result.toCompanyLogo}}">
                                <div class="mobile-text-styling">
                                  <h4 class="mobile-only-text">Via:</h4>
                                  <h4>{{result.midPortName}}</h4>
                                </div>
                                <div class="date-info">
                                  <strong>
                                    Arr:
                                    {{result.midPortArrivalDate | date: 'dd-MM-yyyy'}}
                                  </strong>
                                </div>
                                <div class="date-info">
                                  <strong>
                                    Dep:
                                    {{result.midPortDepartureDate | date: 'dd-MM-yyyy'}}
                                  </strong>
                                </div>
                              </div>
                              <div>
                                <div class="text-transhipment"></div>
                              </div>
                              <div pTooltip="Vessel: {{result.toVesselsName}}">
                                <div class="mobile-text-styling">
                                  <h4 class="mobile-only-text">To:</h4>
                                  <h4>{{result.toPortName}}</h4>
                                </div>
                                <div class="date-info">
                                  <strong>
                                    Arr:
                                    {{result.toPortArrivalDate | date: 'dd-MM-yyyy'}}
                                  </strong>
                                </div>
                              </div>                              
                              <div> 
                                <!-- <div style="margin: 0.5rem;">
                                  {{result.cubicMeter}}
                                </div>                                -->
                                <button class="btn btn-outline-success btn-details my-2 mb-1 rate-request" type="submit"
                                        (click)="getRateRequest(result.shippingLineId, result.fromPortId, result.toPortId)">
                                  Rate Request
                                </button><br class="mobile-break-points" />
                                <br class="mobile-break-points" />
                                <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                        type="submit"
                                        (click)="getTranshipmentVoyage(result.vesselsId,result.toVesselsId,result.midPortId,result.fromPortArrivalDate,result.toPortArrivalDate, result.fromPortId, result.toPortId, result.shippingLineId, result.toShippingLineId)">
                                  Schedule
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr class="tdvm" pTooltip="Vessel: {{result.vesselsName}}" tooltipPosition="top"
                            *ngIf="!result?.isTranshipment || result?.isTranshipment == 0" [ngClass]="result.isPremiumListing == 1 && rowIndex<5 ? 'premiumListing':null">
                          <td>
                            <div class="flexdiv mobile-styling col-lg-12">
                              <div class="col-lg-2 text-center"> <img class="image1" src="{{result.companyLogo}}"> </div>
                              <div class="col-lg-2">
                                <div class="mobile-text-styling">
                                  <h4 class="mobile-only-text">From:</h4>
                                  <h4>{{result.fromPortName}}</h4>
                                </div>
                                <div class="date-info"> {{result.fromPortArrivalDate | date: 'dd-MM-yyyy'}} </div>
                              </div>
                              <div class="col-lg-1">
                                <div class="text-direct"> Direct </div>
                              </div>
                              <div class="col-lg-2">
                                <div class="mobile-text-styling">
                                  <h4 class="mobile-only-text">To:</h4>
                                  <h4>{{result.toPortName}}</h4>
                                </div>
                                <div class="date-info"> {{result.toPortArrivalDate | date: 'dd-MM-yyyy'}}</div>
                              </div>  
                              <!-- <div class="col-lg-1">
                                <label *ngIf="result.cubicMeter" style="text-decoration: underline; color: #000066;"><b> ${{math.trunc(result.cubicMeter)}}</b></label>
                              </div>                             -->
                              <div class="col-lg-4" style="display: inline-flex; padding: 0px !important;">                                
                                <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request" style="width: 90px !important;"
                                        type="submit" (click)="getRateRequest(result.shippingLineId, result.fromPortId, result.toPortId)">
                                 {{result.cubicMeter?'Rate Request':'Rate Request'}}
                                </button>
                                <br class="mobile-break-points" />
                                <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                        type="submit"
                                        (click)="getDetails(result.vesselsId,result.fromPortArrivalDate,result.toPortArrivalDate, result.fromPortId, result.toPortId, result.shippingLineId)">
                                  Schedule
                                </button>
                                <br class="mobile-break-points" />
                                <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                        (click)="tracking(result.shippingLineId,result.vesselsId,result.toPortArrivalDate,result.isTranshipment,result.fromPortId, result.toPortId)">
                                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="15">
                                    <path d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
                                    <path d="M0 0h24v24H0z" fill="none" />
                                  </svg>
                                  Track
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                      <!-- </table> -->
                    </p-table>
                    <div *ngIf="totalCount == 0">
                      <span *ngIf="scheduleRroute == 0" class="no-voyage-message">
                        <b>
                          No direct sailings found. Please check transhipment options by
                          clicking on "Transhipment" above.
                        </b>
                      </span>
                      <span *ngIf="scheduleRroute == 1" class="no-voyage-message">
                        <b>No Transhipment found.</b>
                      </span>
                    </div>
                  </div>

                </div>
                <div class="pageBox mt-4">
                  <p-paginator *ngIf="totalCount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
                               [totalRecords]="totalCount" (onPageChange)="paginate($event)" #p></p-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
          <div class="container">
            <div class="row">
              <div class="col-lg-3">
                <div class="filter-sec">
                  <p-accordion>
                    <p-accordionTab header="Shipping Lines" [selected]="true">
                      <div class="shipping-sec">
                        <div class="shipping-lines">
                          <h4>
                            Shipping Lines
                          </h4>
                          <div class="select-section-relative">
                            <p-multiSelect [options]="shippingLines" [(ngModel)]="selectedShipLines"
                                           optionLabel="shippingLineName" [virtualScroll]="true" [filter]="false"
                                           (onChange)="getSelectedShippingLine($event)">
                            </p-multiSelect>
                          </div>
                          <div class="box-sec-outer" style="display: block;margin-top: 5px;">
                            <ul class="list-group border-0">
                              <li class="list-group-item d-flex justify-content-between align-items-center border-0"
                                  style="padding: 0.3rem 0.25rem;" *ngFor="let ship of selectedShipLines; let i = index;">
                                {{ship.shippingLineName}}
                                <span class="badge badge-secondary badge-pill" (click)='removeShips(ship)'
                                      style="cursor: pointer;">
                                  x
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab header="Times">
                      <section class="timer-sec">
                        <div class="departure-sec">
                          <h4>Departure {{departurePortName}}</h4>
                          <div class="departure-sec-inner">
                            <div class="time-image" *ngIf="IsFilter">
                              <ng5-slider [(value)]="valueArrival" [options]="arroption"
                                          (userChangeEnd)="fromPortChangeSlidder($event)">
                              </ng5-slider>
                            </div>
                          </div>
                        </div>
                        <div class="departure-sec">
                          <h4>Arrival {{arrivalPortName}}</h4>
                          <div class="departure-sec-inner">
                            <div class="time-image" *ngIf="IsFilter">
                              <ng5-slider [(value)]="valueDep" [options]="OptionsDep"
                                          (userChangeEnd)="toPortChangeSlidder($event)">
                              </ng5-slider>
                            </div>
                          </div>
                        </div>
                      </section>
                    </p-accordionTab>
                    <p-accordionTab header="Transhipment Ports" *ngIf="transhipmentPorts.length > 0">
                      <section class="timer-sec">
                        <div class="departure-sec">
                          <p-dropdown [options]="transhipmentPorts" [(ngModel)]="selectedTranshipmentPort"
                                      optionLabel="portName" class="select-dropdown-sec" placeholder="Select Port"
                                      [virtualScroll]="true" (onChange)="filterByTranshipmentPorts($event)" [itemSize]="5"
                                      [filter]="false"></p-dropdown>
                        </div>
                      </section>
                    </p-accordionTab>
                  </p-accordion>
                </div>
                <div class="serachresultfiter filter-sec mt-1">
                  ENL Solutions is not responsible for the accuracy of the
                  information.The information can be changed by the
                  shipping line at any time and without any notice
                </div>

                <div class="serachresultfiter filter-sec mt-1">
                  <!-- Enl-solutions's Ad Server / Banner / 250x250 / Square Pop-Up -->
                  <iframe src="https://media.aso1.net/js/ifr.html?id=67818" width="220" height="220" align="center" frameborder="0" hspace="0" vspace="0" marginheight="0" marginwidth="0" scrolling="no" style="width:220px; height:220px; overflow:hidden; border:none;"></iframe>
                  <!-- /Enl-solutions's Ad Server -->
                </div>

              </div>
              <div class="col-lg-9">
                <div class="table-sec">
                  <div class="table-responsive">
                    <p-table [value]="Quickestserchres" *ngIf="totalCount > 0">
                      <ng-template pTemplate="body" let-quickdet let-rowIndex="rowIndex">
                        <tr *ngIf="quickdet.isTranshipment == 1">
                          <td tooltipPosition="top" class="second-child"
                              pTooltip="Vessel: {{quickdet.vesselsName}} &#xA; Dep.: {{quickdet.fromPortName}} &#xA; Dep. Date: {{quickdet.fromPortDepartureDate}} &#xA; Arr.: {{quickdet.midPortName}} &#xA; Arr. Date: {{quickdet.midPortDepartureDate}}">
                            <img src="{{quickdet.LogoUrl}}" class="image1">
                          </td>
                          <td class="second-child" tooltipPosition="top"
                              pTooltip="Vessel: {{quickdet.toVesselsName}} &#xA; Dep.: {{quickdet.midPortName}} &#xA; Dep. Date: {{quickdet.midPortDepartureDate}} &#xA; Arr.: {{quickdet.toPortName}} &#xA; Arr. Date: {{quickdet.toPortArrivalDate}}">
                            <img src="{{quickdet.toCompanyLogo}}" class="image1">
                          </td>
                          <td class="transipment-chart">
                            <p-chart type="horizontalBar" [data]="quickdet.quickestdata" [options]="optionsquick"
                                     [responsive]="true" height="100px" width="185px"></p-chart>
                          </td>
                          <td class="second-child-button">
                            <!-- {{result.cubicMeter}} -->
                            <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request" type="submit"
                                    (click)="getRateRequest(quickdet.shippingLineId,quickdet.fromPortId, quickdet.toPortId)">
                              Rate Request
                            </button>
                            <br />
                            <button class="btn btn-outline-success btn-details my-1 my-sm-0 rate-request" type="submit"
                                    (click)="getTranshipmentVoyage(quickdet.vesselsId,quickdet.toVesselsId,quickdet.midPortId,quickdet.fromPortDepartureDate,quickdet.toPortArrivalDate, quickdet.fromPortId, quickdet.toPortId,quickdet.shippingLineId, quickdet.toShippingLineId)">
                              Schedule
                            </button>
                            <br />
                            <button class="btn btn-outline-success btn-details smy-2 my-sm-0 rate-request"
                                    (click)="tracking(quickdet.shippingLineId,quickdet.vesselsId,quickdet.fromPortDepartureDate,quickdet.isTranshipment,quickdet.fromPortId, quickdet.toPortId)">
                              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                <path d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
                                <path d="M0 0h24v24H0z" fill="none" />
                              </svg>
                              Track
                            </button>
                          </td>
                        </tr>
                        <tr *ngIf="quickdet.isTranshipment == 0">
                          <td tooltipPosition="top" class="second-child"
                              pTooltip="Vessel: {{quickdet.vesselsName}} &#xA; Dep.: {{quickdet.fromPortName}} &#xA; Dep. Date: {{quickdet.fromPortDepartureDate}} &#xA; Arr.: {{quickdet.toPortName}} &#xA; Arr. Date: {{quickdet.toPortArrivalDate}}">
                            <img src="{{quickdet.LogoUrl}}" class="image1">
                          </td>
                          <td class="direct-chart">
                            <p-chart type="horizontalBar" [data]="quickdet.quickestdata" [options]="optionsquick"
                                     [responsive]="true" height="100px" width="255px"></p-chart>
                          </td>
                          <td class="second-child-button">
                            <!-- {{result.cubicMeter}} -->
                            <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request" type="submit"
                                    (click)="getRateRequest(quickdet.shippingLineId,quickdet.fromPortId, quickdet.toPortId)">
                              Rate Request
                            </button>
                            <button class="btn btn-outline-success btn-details my-1 my-sm-0 rate-request" type="submit"
                                    (click)="getDetails(quickdet.vesselsId,quickdet.fromPortDepartureDate,quickdet.toPortArrivalDate, quickdet.fromPortId, quickdet.toPortId, quickdet.shippingLineId)">
                              Schedule
                            </button>
                            <button class="btn btn-outline-success btn-details my-2 my-sm-0 rate-request"
                                    (click)="tracking(quickdet.shippingLineId,quickdet.vesselsId,quickdet.fromPortDepartureDate,quickdet.isTranshipment,quickdet.fromPortId, quickdet.toPortId)">
                              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                                <path d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
                                <path d="M0 0h24v24H0z" fill="none" />
                              </svg>
                              Track
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                    <div *ngIf="totalCount == 0">
                      <span>No records found</span>
                    </div>
                  </div>
                </div>
                <div class="pageBox mt-4">
                  <p-paginator *ngIf="totalCount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
                               [totalRecords]="totalCount" (onPageChange)="paginatequickest($event)" #p></p-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
          <div class="container">
            <div class="row">
              <div class="col-lg-3">
                <div class="filter-sec">
                  <p-accordion>
                    <p-accordionTab header="Shipping Lines" [selected]="true">
                      <div class="shipping-sec">
                        <div class="shipping-lines">
                          <h4>
                            Shipping Lines
                          </h4>
                          <div class="select-section-relative">
                            <p-multiSelect [options]="shippingLines" [(ngModel)]="selectedShipLines"
                                           optionLabel="shippingLineName" [virtualScroll]="true" [filter]="false"
                                           (onChange)="getSelectedShippingLine($event)">
                            </p-multiSelect>
                          </div>
                          <div class="box-sec-outer" style="display: block;margin-top: 5px;">
                            <ul class="list-group border-0">
                              <li class="list-group-item d-flex justify-content-between align-items-center border-0"
                                  style="padding: 0.3rem 0.25rem;" *ngFor="let ship of selectedShipLines; let i = index;">
                                {{ship.shippingLineName}}
                                <span class="badge badge-secondary badge-pill" (click)='removeShips(ship)'
                                      style="cursor: pointer;">
                                  x
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab header="Times">
                      <section class="timer-sec">
                        <div class="departure-sec">
                          <h4>Departure {{departurePortName}}</h4>
                          <div class="departure-sec-inner">
                            <div class="time-image" *ngIf="IsFilter">
                              <ng5-slider [(value)]="valueArrival" [options]="arroption"
                                          (userChangeEnd)="fromPortChangeSlidder($event)">
                              </ng5-slider>
                            </div>
                          </div>
                        </div>
                        <div class="departure-sec">
                          <h4>Arrival {{arrivalPortName}}</h4>
                          <div class="departure-sec-inner">
                            <div class="time-image" *ngIf="IsFilter">
                              <ng5-slider [(value)]="valueDep" [options]="OptionsDep"
                                          (userChangeEnd)="toPortChangeSlidder($event)">
                              </ng5-slider>
                            </div>
                          </div>
                        </div>
                      </section>
                    </p-accordionTab>
                    <p-accordionTab header="Transhipment Ports" *ngIf="transhipmentPorts.length > 0">
                      <section class="timer-sec">
                        <div class="departure-sec">
                          <p-dropdown [options]="transhipmentPorts" [(ngModel)]="selectedTranshipmentPort"
                                      optionLabel="portName" class="select-dropdown-sec" placeholder="Select Port"
                                      [virtualScroll]="true" (onChange)="filterByTranshipmentPorts($event)" [itemSize]="5"
                                      [filter]="false"></p-dropdown>
                        </div>
                      </section>
                    </p-accordionTab>
                  </p-accordion>
                </div>
                <div class="serachresultfiter filter-sec mt-1">
                  ENL Solutions is not responsible for the accuracy of the
                  information.The information can be changed by the
                  shipping line at any time and without any notice
                </div>

                <div class="serachresultfiter filter-sec mt-1">
                  <!-- Enl-solutions's Ad Server / Banner / 250x250 / Square Pop-Up -->
                  <iframe src="https://media.aso1.net/js/ifr.html?id=67818" width="220" height="220" align="center" frameborder="0" hspace="0" vspace="0" marginheight="0" marginwidth="0" scrolling="no" style="width:220px; height:220px; overflow:hidden; border:none;"></iframe>
                  <!-- /Enl-solutions's Ad Server -->
                </div>

              </div>
              <div class="col-lg-9">
                <div class="table-sec">
                  <div class="table-responsive">
                    <p-table [value]="chepestserchres" *ngIf="totalCount > 0">
                      <ng-template pTemplate="body" let-quickdet let-rowIndex="rowIndex">
                        <tr *ngIf="quickdet.isTranshipment == 1">
                          <td tooltipPosition="top"
                              pTooltip="Vessel: {{quickdet.vesselsName}} &#xA; Dep.: {{quickdet.fromPortName}} &#xA; Dep. Date: {{quickdet.fromPortDepartureDate}} &#xA; Arr.: {{quickdet.midPortName}} &#xA; Arr. Date: {{quickdet.midPortArrivalDate}}">
                            <img src="{{quickdet.LogoUrl}}" class="image1">
                          </td>
                          <td class="second-child" tooltipPosition="top"
                              pTooltip="Vessel: {{quickdet.toVesselsName}} &#xA; Dep.: {{quickdet.midPortName}} &#xA; Dep. Date: {{quickdet.midPortDepartureDate}} &#xA; Arr.: {{quickdet.toPortName}} &#xA; Arr. Date: {{quickdet.toPortArrivalDate}}">
                            <img src="{{quickdet.toCompanyLogo}}" class="image1">
                          </td>
                          <td>
                            <p-chart type="horizontalBar" [data]="quickdet.quickestdata" [options]="optionsquick"
                                     [responsive]="true" height="100px" width=""></p-chart>
                          </td>
                          <td class="second-child">
                            <button class="btn btn-outline-success btn-details my-1 my-sm-0" type="submit"
                                    (click)="getTranshipmentVoyage(quickdet.vesselsId,quickdet.toVesselsId,quickdet.midPortId,quickdet.fromPortDepartureDate,quickdet.toPortArrivalDate, quickdet.fromPortId, quickdet.toPortId,quickdet.shippingLineId, quickdet.toShippingLineId)">
                              DETAILS
                            </button>
                          </td>
                        </tr>
                        <tr *ngIf="quickdet.isTranshipment == 0">
                          <td tooltipPosition="top"
                              pTooltip="Vessel: {{quickdet.vesselsName}} &#xA; Dep.: {{quickdet.fromPortName}} &#xA; Dep. Date: {{quickdet.fromPortDepartureDate}} &#xA; Arr.: {{quickdet.toPortName}} &#xA; Arr. Date: {{quickdet.toPortArrivalDate}}">
                            <img src="{{quickdet.LogoUrl}}" class="image1">
                          </td>
                          <td>
                            <p-chart type="horizontalBar" [data]="quickdet.quickestdata" [options]="optionsquick"
                                     [responsive]="true" height="100px" width=""></p-chart>
                          </td>
                          <td class="second-child">
                            <button class="btn btn-outline-success btn-details my-1 my-sm-0" type="submit"
                                    (click)="getDetails(quickdet.vesselsId,quickdet.fromPortDepartureDate,quickdet.toPortArrivalDate,quickdet.fromPortId, quickdet.toPortId, quickdet.shippingLineId)">
                              DETAILS
                            </button>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                    <div *ngIf="totalCount == 0">
                      <span>No records found</span>
                    </div>
                  </div>
                  <p-paginator *ngIf="totalCount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
                               [totalRecords]="totalCount" (onPageChange)="paginatechepest($event)" #p></p-paginator>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #cd>
  <p-footer>
    <!-- <button type="button" *ngIf="!isFreeSearchesFinished" pButton  label="Search" (click)="cd.reject()"></button> -->
    <button type="button" pButton label="{{yesButtonText}}" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
